/** 横向概览仅保留紧急标记及数量；取消原侧栏，留出连续色带空间，不恢复已移除的工种列表。
 * 统计按当前日期范围去重后的全部任务计算；取消任务保留可查但不计工作量。
 */
import React from "react";
import { SCHEDULE_PRIORITIES } from "./SchedulePriority";

export default function ScheduleSidebar({ tasks, view, zh }) {
  // 新版采用横向概览，释放七列日历宽度；跨天色带仍只计一项，不随绘制区段增加数量。
  const counts = { normal: 0, urgent: 0, critical: 0 };
  tasks.filter((t) => t.status !== "cancelled").forEach((task) => { counts[Object.hasOwn(counts, task.priority) ? task.priority : "normal"] += 1; });
  const total = Object.values(counts).reduce((sum, n) => sum + n, 0);
  return <aside className="flex flex-wrap items-center gap-x-5 gap-y-2 border-b border-slate-100 bg-slate-50/60 px-4 py-3 sm:px-5" aria-label={zh ? "紧急程度与概览" : "Urgency and overview"} data-testid="schedule-overview">
    <p className="text-xs text-slate-600"><span className="font-semibold text-slate-800">{zh ? (view === "week" ? "本周" : "本月") : (view === "week" ? "This week" : "This month")}</span><span className="mx-2 text-slate-300">/</span>{total} {zh ? "项任务" : "assignments"}</p>
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs">{["critical", "urgent", "normal"].map(id => <span key={id} className="inline-flex items-center gap-1.5">
      <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{ backgroundColor: SCHEDULE_PRIORITIES[id].borderColor }} />
      <span className="text-slate-600">{SCHEDULE_PRIORITIES[id][zh ? "zh" : "en"]}</span>
      <strong data-testid={`schedule-count-${id}`} className="tabular-nums text-slate-900">{counts[id]}</strong>
    </span>)}</div>
  </aside>;
}
